export default {
  init() {
    // JavaScript to be fired on the checkout page
  },
  finalize() {
    jQuery('[name="checkout"], .cart-collaterals').on('change', '[data-local-pickup-select]', (event) => {
      jQuery('[data-local-pickup-input]').val(jQuery(event.currentTarget).val());
      const location_string = jQuery(event.currentTarget).find('option:selected').data('pickup-location-address');
      jQuery('[data-pickup-location-address-display]').html(location_string);
    });

    jQuery(document.body).on( 'change', 'input.shipping_method', () => {
      if (jQuery('.woocommerce-shipping-methods input[type="radio"]:checked').val().split(':')[0] === 'local_pickup') {
        jQuery('body').addClass('local-pickup-selected');
      } else {
        jQuery('body').removeClass('local-pickup-selected');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js